<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2024-05-10 17:35:20
 * @LastEditors: whaoo
 * @LastEditTime: 2024-06-24 09:38:11
-->
<template>
  <div class="sidebar">
    <img src="../../assets/sidebar_newbg.png" class="sidebar_bg" alt />
    <div class="logo_box">
      <img src="../../assets/sidebar_newlogo.png" alt @click="logout" />
      <div class="project_name">体征遥测管理系统</div>
      <div class="zone_name">{{ zone_name }}</div>
    </div>

    <div class="z_2 sidebar_box">
      <el-menu background-color="#ffffff00" :router="true" :default-active="activeIndex" text-color="#2F3538"
        active-text-color="#ffffff">
        <el-menu-item index="/all_device_data">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/all_device_data'"
              src="../../assets/icon/menu_icon_1.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_1_a.png">
            <div>实时体征监测</div>
          </div>
        </el-menu-item>
        <el-menu-item index="/device_list">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/device_list'" src="../../assets/icon/menu_icon_2.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_2_a.png">
            <div>护理服务报告</div>
          </div>
        </el-menu-item>
        <el-menu-item index="/device_manage">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/device_manage'" src="../../assets/icon/menu_icon_3.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_3_a.png">
            <div>设备管理</div>
          </div>
        </el-menu-item>
        <el-menu-item index="/huanz_list">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/huanz_list'" src="../../assets/icon/menu_icon_4.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_4_a.png">
            <div>患者列表</div>
          </div>
        </el-menu-item>
        <!-- <el-menu-item index="/sleep_report">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/sleep_report'" src="../../assets/icon/menu_icon_5.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_5_a.png">
            <div>睡眠质量分析</div>
          </div>
        </el-menu-item> -->
        <el-menu-item index="/activity_report">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/activity_report'" src="../../assets/icon/menu_icon_6.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_6_a.png">
            <div>运动健康分析</div>
          </div>
        </el-menu-item>
        <el-menu-item index="/activity_statics">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/activity_statics'" src="../../assets/icon/menu_icon_8.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_8_a.png">
            <div>活动情况统计</div>
          </div>
        </el-menu-item>
        <el-menu-item index="/device_log">
          <div class="flex_center">
            <img class='sidebar_logo' v-if="activeIndex == '/device_log'" src="../../assets/icon/menu_icon_7.png" />
            <img class='sidebar_logo' v-else src="../../assets/icon/menu_icon_7_a.png">
            <div>设备使用日志</div>
          </div>
        </el-menu-item>
      </el-menu>
    </div>
    <el-dialog :visible.sync="logoutDialog" title="退出登录" width="580px" top="25vh">
      <div class="logout">
        <i class="el-icon-warning el-icon-iconName " color="#e6a23c"></i><span>是否注销账户，重新登录？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="info" @click="logoutDialog = false">取 消</el-button> -->
        <!-- <el-button type="primary" @click="logoutConfirm">确 定</el-button> -->
        <div class="flex_center_center">
            <div class="custom_btn info_btn" @click="logoutDialog = false">取 消</div>
            <div class="custom_btn primary_btn" @click="logoutConfirm">确 定</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "",
      logoutDialog: false,
      zone_name:""
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = this.$route.path;
    },
  },
  mounted() {
    this.activeIndex = this.$route.path;
    this.zone_name = localStorage.getItem('zone_name')
  },

  methods: {
    logout() {
      this.logoutDialog = true
    },
    logoutConfirm() {
      localStorage.clear()
      this.$router.push('/login')
    }
  },
};
</script>
<style scoped>
.sidebar {
  height: 100%;
  position: relative;
  width: 100%;
}

.sidebar_bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.z_2 {
  z-index: 2;
  position: relative;
}

.sidebar_box {
  padding: 0px 10px;
}

.sidebar_box>>>.el-menu-item {
  border-radius: 10px;
  height: 64px;
  line-height: 64px;
  margin-bottom: 24px;
} 

.sidebar_box>>>.el-menu-item:hover {
  background-color: #57a8ffaa !important;
}

.sidebar_box>>>.el-menu-item.is-active {
  background-color: #57a8ff !important;
}

.logo_box {
  height: 284px;
  z-index: 2;
  position: relative;
  text-align: center;
  padding-top: 40px;
}

.logo_box img {
  width: 100px;
  height: 100px;
  margin-bottom: 30px;
  cursor: pointer;
}

.project_name {
  font-size: 24px;
  color: #384951;
  height: 24px;
  line-height: 24px;
  margin-bottom: 16px;
  font-family: 'SourceHanSansCN-Bold';
  font-weight: bold;
}

.zone_name {
  font-size: 18px;
  color: #57A8FF;
  height: 18px;
  line-height: 18px;
}

.logout {
  height: 146px;
  line-height: 146px;
  color: #e6a23c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.logout span {
  color: #636676;
  margin-left: 5px;
}

.sidebar_logo {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.flex_center {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
}

.sidebar_box>>>.is-active .flex_center {
  font-family: 'SourceHanSansCN-Bold';
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/view/layout/sidebar.vue